export default {
  computed: {
    locales() {
      return [this.locale];
    },
    translations() {
      let trans = {};
      this.locales.map(locale => {
        trans[locale] = Object.assign(this.defaultTrans[locale], this.trans);
      });
      return trans;
    }
  },
  data: function() {
    return {
      defaultTrans: {
        'en': {},
        'en_GB': {}
      }
    };
  },
  props: {
    /**
      * Locale to use for current instance
      */
    locale: {type: String, default: 'en_GB'},
    /**
      * Key-value pairs of translations (en => target locale)
      */
    trans: {type: Object, default: function() {
      return {};
    }},
  },
  methods: {
    $t: function(msgid)
    {
      return this.translations[this.locale][msgid];
    }
  }
};
